export default "__VITE_ASSET__IlEFKHc2__"